import Modal from './Modal'
import { useEffect, useState } from 'react'
import { initSpinDuration } from '../../../UI/Cube/Cube'
import props from '../../../../redux/props'
import { useSelector } from 'react-redux'
import bierdeckel from '../../../../assets/image/bierdeckelPopup/bierdeckel.webp'
import close from '../../../../assets/image/close.svg'

const BierdeckelPopup: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [isVisible, setIsVisible] = useState(false)

  const toggle = () => setIsVisible(!isVisible)

  useEffect(() => {
    const popupParam = new URL(window.location.href).searchParams.get('popup')
    const showPopup = !popupParam
    if (showPopup) {
      setTimeout(() => {
        setIsVisible(true)
        // const url = new URL(window.location.href)
        // url.searchParams.set('popup', 'false')
        // window.history.pushState({}, '', url)
      }, initSpinDuration * 1100)
    }
  }, [])

  return (
    <Modal noForm show={isVisible} closeIcon onClose={toggle}>
      <div className="pt-12 pb-8 px-5 md:p-10 bg-red relative">
        <div className="cursor-pointer absolute top-[10px] right-[10px]">
          <img onClick={toggle} src={close} className="w-6 h-6" alt="" />
        </div>
        <div className="text-center leading-[40px] text-[38px] md:leading-[60px] md:text-[55px] uppercase text-white font-bolder">
          {t.cubeBierdeckelPopup.title1}
        </div>
        <div className="text-center leading-[40px] text-[38px] md:leading-[60px] md:text-[55px] uppercase text-white font-bolder">
          {t.cubeBierdeckelPopup.title2}
        </div>
        <div className="px-3">
          <img src={bierdeckel} alt="Bierdeckel" className="w-full mt-5" />
        </div>
      </div>
    </Modal>
  )
}

export default BierdeckelPopup
